import { authApi } from "@api";
import { PATH_HOME } from "@configs";
import { selectAuth } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";
// import { PATH_HOME } from '@configs'; // uncomment if PATH_HOME constant desired

export const PageAuth = () => {
    //page hook
    const history = useHistory();
    const { auth } = useSelector(selectAuth);
    const accessToken = auth ?? UserStore((s: any) => s.accessToken);
    const { id } = useParams<{ id: string }>();
    
    // Parse URL parameters to get redirect path
    const searchParams = new URLSearchParams(window.location.search);
    const redirectParam = searchParams.get('redirect');

    const verifyToken = async (token: string) => {
        try {
            UIStore.setState({ isLoading: true });
            const response = await authApi.verifyToken(token);
            if (response?.status === 200) {
                UserStore.setState({ accessToken: token });
                UserStore.setState({ isLoggedIn: true });
            }
        } catch (e: any) {
            console.error("[PageAuth] verifyToken error", e);
        } finally {
            // Redirect based on the redirect parameter, defaulting to home
            const redirectPath = redirectParam ? `/${redirectParam}` : PATH_HOME;
            history.replace(redirectPath);
            UIStore.setState({ isLoading: false });
        }
    };

    useEffect(() => {
        if (accessToken) {
            // Redirect based on the redirect parameter, defaulting to home
            const redirectPath = redirectParam ? `/${redirectParam}` : PATH_HOME;
            history.replace(redirectPath);
        } else {
            verifyToken(id);
        }
    }, [accessToken, id, redirectParam]);

    return <StyledContainer></StyledContainer>;
};

const StyledContainer = styled.div`
    height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
